import type { Vacancy } from 'clients/AutoCompleteClient/types';
import type { NotifyCandidateMethod } from 'clients/CampaignsClient/CampaignsClient.types';
import type { CandidateStatus } from 'services/candidates';
import type { CampaignJobboard } from 'shared/legacy/contexts/SelectedCampaignContext/SelectedCampaignContext.types';
import type { ICandidate } from 'types/candidate';

export enum CandidateEvent {
  StartTransaction = 'CandidateEvent:StartTransaction',

  Contacted = 'CandidateEvent:Contacted',
  Unlocked = 'CandidateEvent:Unlocked',
  LabelsUpdated = 'CandidateEvent:LabelsUpdated',
  CommitTransaction = 'CandidateEvent:CommitTransaction',
}

export enum EnrichVacancyEvent {
  Selected = 'EnrichVacancyEvent:Selected',
  Deleted = 'EnrichVacancyEvent:Deleted',
}

type CandidateEventPayload = {
  [CandidateEvent.Contacted]: {
    esPersonId: string;
    contactMethod: NotifyCandidateMethod;
    status: CandidateStatus;
    activeJobBoard: CampaignJobboard;
  };
  [CandidateEvent.Unlocked]: {
    campaignId: string | number;
    esPersonId: string;
    reason: ICandidate.UnlockReason;
  };
  [CandidateEvent.LabelsUpdated]: {
    labels: string[];
    esPersonId: string;
  };
  [CandidateEvent.StartTransaction]: {
    name: string;
    esPersonId: string;
    status: CandidateStatus;
    labels: string[];
  };
  [CandidateEvent.CommitTransaction]: {
    transactionKey: string;
    history: TransactionRecord<Event, Payload<Event>>[];
  };
};

type EnrichVacancyEventPayload = {
  [EnrichVacancyEvent.Selected]: {
    vacancy: Vacancy;
  };
  [EnrichVacancyEvent.Deleted]: {
    vacancyId: number;
  };
};

type EventPayload = CandidateEventPayload & EnrichVacancyEventPayload;

type Payload<E extends Event> = E extends keyof EventPayload ? EventPayload[E] : any;

type TransactionRecord<E extends Event, P extends Payload<E> = Payload<E>> = {
  event: E;
  payload: P;
  timestamp: number;
  result?: any;
};

type CandidateEventTransactionItem = { [K in CandidateEvent]: TransactionRecord<K> }[CandidateEvent];

type Event = CandidateEvent | EnrichVacancyEvent;

/**
 * EventBus types
 */

export type EventBusEvent = Event;
export type EventBusPayload<E extends EventBusEvent> = Payload<E>;
export type EventBusTransactionRecord<
  E extends EventBusEvent,
  P extends EventBusPayload<E> = EventBusPayload<E>,
> = TransactionRecord<E, P>;
export type EventBusCandidateEventTransactionItem = CandidateEventTransactionItem;
